import {
    getPaymentLink, getPaymentLinkSuccess, getPaymentLinkFailure,

    getAllPaymentlinksListExport,
    getAllPaymentLinkSuccess,
    getAllPaymentLinkFailure,
    
} from "./paymentlinks.action";


import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { SharedService } from '../../shared/shared.service';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { LoaderService } from '../../core/services/loader.service';
import { finalize } from 'rxjs/operators';
import { Validations } from '../../shared/constants/validations';
import { SweetAlertIcon } from '../../shared/constants/enum';
import { BillsService } from "../../core/services/bills.service";
import { PaymentLinkService } from "../../core/services/paymentLink.service";

@Injectable()
export class PaymentLinksEffects {
    ServiceError = Validations.ServiceError;

    getPaymentLink$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getPaymentLink),
            exhaustMap(({ pageIndex, pageSize, searchTerm, projectId, filter,
                orderBy, }) => {
                if (!searchTerm) {
                    this.loaderService.setLoading(true);
                }
                return this.paymentlinksService.getpaymentLinksData(pageIndex, pageSize, searchTerm, projectId, filter,
                    orderBy,).pipe(
                        map((response: any) => {
                            this.loaderService.setLoading(false);
                            console.log(response);
                            if (response && response.statusCode === 200) {
                                return getPaymentLinkSuccess({ getpaymentLinkResponse: response.data });
                            } else {
                                return getPaymentLinkFailure({ getpaymentlinkError: response });
                            }
                        }),
                        catchError((error) => {
                            console.log(error);
                            this.sharedService.showMessageDialog(error.error.message, this.ServiceError.Error, SweetAlertIcon.ERROR);
                            return of(getPaymentLinkFailure({ getpaymentlinkError: error }));
                        }), finalize(() => this.loaderService.setLoading(false))
                    );
            })
        )
    );


    getAllPaymentlinksListExport$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getAllPaymentlinksListExport),
            exhaustMap(({ pageIndex, pageSize, searchTerm, projectId, filter,
                orderBy, }) => {
                if (!searchTerm) {
                    this.loaderService.setLoading(true);
                }
                return this.paymentlinksService.getpaymentLinksData(pageIndex, pageSize, searchTerm, projectId, filter,
                    orderBy,).pipe(
                        map((response: any) => {
                            this.loaderService.setLoading(false);
                            console.log(response);
                            if (response && response.statusCode === 200) {
                                return getAllPaymentLinkSuccess({ getallpaymentlinkExportResponse: response.data });
                            } else {
                                return getAllPaymentLinkFailure({ getallpaymentlinkExportError: response });
                            }
                        }),
                        catchError((error) => {
                            console.log(error);
                            this.sharedService.showMessageDialog(error.error.message, this.ServiceError.Error, SweetAlertIcon.ERROR);
                            return of(getAllPaymentLinkFailure({ getallpaymentlinkExportError: error }));
                        }), finalize(() => this.loaderService.setLoading(false))
                    );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private router: Router,
        private paymentlinksService: PaymentLinkService,
        private loaderService: LoaderService,
        private sharedService: SharedService,
    ) { }


}